<template>
  <div v-if="show" class="mb-2 container-fluid py-1" :class="[mainClass]">
    <div class="py-1 row">

      <!-- Breadcrumbs -->
      <div :class="[showSwitchers ? 'col-4' : 'col-12']">
        <ol class="breadcrumb" style="background-color:transparent;">
          <li v-for="(breadcrumb, index) in breadcrumbs" :key="index"
                class="breadcrumb-item">
            <router-link :to="breadcrumb.to" v-html="breadcrumb.text" v-if="breadcrumb.to"></router-link>
            <span v-html="breadcrumb.text" v-else :class="{ 'font-weight-bold': index === breadcrumbs.length - 1 }"></span>
          </li>
        </ol>
      </div>

      <div class="col-4" v-if="showSwitchers">
        <tenant-selector/>
      </div>

      <div class="col-4" v-if="showSwitchers && isMenu">
        <menu-selector/>
      </div>

    </div>

  </div>
</template>

<script>
import { mapState } from 'vuex'
import userInfoMixin from '@/common/mixins/user-info-mixin'
import TenantSelector from '@/common/elements/TenantSelector'
import MenuSelector from '@/common/elements/MenuSelector'

export default {
  name: 'breadcrumbs',
  mixins: [userInfoMixin],
  components: { MenuSelector, TenantSelector },
  computed: {
    ...mapState('login', ['activeLocation']),
    breadcrumbs () {
      return this.$store.state.main.breadcrumbs
    },
    screen () {
      const pathTop = this.$route.path.split('/')[1]
      return pathTop
    },
    isAdmin () {
      return this.$route.path.split('/')[2] === 'admin'
    },
    isMenu () {
      return this.screen === 'menu' ||
        (this.screen === 'kiosk' && this.$route.path.split('/')[2] === 'menu')
    },
    mode () {
      if (this.activeLocation) {
        return this.activeLocation.type === 'GROUP'
          ? 'group'
          : 'location'
      }
      return 'company'
    },
    show () {
      return this.breadcrumbs && this.breadcrumbs.length
    },
    showSwitchers () {
      return !this.isAdmin && ['employment', 'locationSettings', 'menu', 'kiosk', 'customer'].includes(this.screen)
    },
    mainClass () {
      return this.showSwitchers
        ? this.mode + '-mode'
        : 'breadcrumb'
    }
  }
}
</script>

<style scoped>
.breadcrumb { margin: 0; }
</style>
